module.exports = __webpack_public_path__ + "img/portalmanagement_accredit_user.d3845e9a.png";